import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Heart, ExternalLink, Mail, MessageCircle, Dices } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const Footer: React.FC = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-dark-800/80 backdrop-blur-sm border-t border-dark-700">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand Section */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-8 h-8 bg-gradient-to-r from-purple-600 to-purple-400 rounded-lg flex items-center justify-center">
                <Dices className="w-5 h-5 text-white" />
              </div>
              <span className="jojobet-logo text-xl">
                <span className="JojoBet-text">DİMARİA</span>
                <span className="bet-text"></span>
              </span>
            </div>
            <p className="text-gray-400 mb-6 max-w-md">
              {t('navigation:footer.brand.description')}
            </p>
            <div className="flex space-x-4">
              <motion.a
                href="#"
                target="_blank"
                rel="noopener noreferrer"
                whileHover={{ scale: 1.1 }}
                className="w-10 h-10 bg-dark-700 hover:bg-red-600 rounded-lg flex items-center justify-center transition-colors"
              >
                <MessageCircle className="w-5 h-5 text-gray-400 hover:text-white" />
              </motion.a>
              <motion.button
                type="button"
                whileHover={{ scale: 1.1 }}
                className="w-10 h-10 bg-dark-700 hover:bg-yellow-600 rounded-lg flex items-center justify-center transition-colors"
              >
                <Mail className="w-5 h-5 text-gray-400 hover:text-white" />
              </motion.button>
              <motion.button
                type="button"
                whileHover={{ scale: 1.1 }}
                className="w-10 h-10 bg-dark-700 hover:bg-purple-600 rounded-lg flex items-center justify-center transition-colors"
              >
                <ExternalLink className="w-5 h-5 text-gray-400 hover:text-white" />
              </motion.button>
            </div>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">{t('navigation:footer.sections.games')}</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/slotlar" className="text-gray-400 hover:text-yellow-400 transition-colors">
                  {t('navigation:footer.links.slots')}
                </Link>
              </li>
              <li>
                <Link to="/canli-casino" className="text-gray-400 hover:text-yellow-400 transition-colors">
                  {t('navigation:footer.links.liveCasino')}
                </Link>
              </li>
              <li>
                <Link to="/spor-bahisleri" className="text-gray-400 hover:text-yellow-400 transition-colors">
                  {t('navigation:footer.links.sports')}
                </Link>
              </li>
              <li>
                <Link to="/etkinlikler/turnuvalar" className="text-gray-400 hover:text-yellow-400 transition-colors">
                  {t('navigation:footer.links.tournaments')}
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">{t('navigation:footer.sections.help')}</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/diger/canli-destek" className="text-gray-400 hover:text-yellow-400 transition-colors">
                  {t('navigation:footer.links.liveSupport')}
                </Link>
              </li>
              <li>
                <Link to="/diger/blog" className="text-gray-400 hover:text-yellow-400 transition-colors">
                  {t('navigation:footer.links.blog')}
                </Link>
              </li>
              <li>
                <Link to="/etkinlikler/promosyonlar" className="text-gray-400 hover:text-yellow-400 transition-colors">
                  {t('navigation:footer.links.promotions')}
                </Link>
              </li>
              <li>
                <Link to="/diger/uygulama" className="text-gray-400 hover:text-yellow-400 transition-colors">
                  {t('navigation:footer.links.mobileApp')}
                </Link>
              </li>
              <li>
                <Link to="/terms-of-service" className="text-gray-400 hover:text-yellow-400 transition-colors">
                  {t('navigation:footer.links.terms')}
                </Link>
              </li>
              <li>
                <Link to="/privacy-policy" className="text-gray-400 hover:text-yellow-400 transition-colors">
                  {t('navigation:footer.links.privacy')}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-dark-700 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © {currentYear} JojoBet. {t('common:copyright')}
          </p>
          <div className="flex items-center space-x-2 mt-4 md:mt-0">
            <span className="text-gray-400 text-sm">{t('common:madeWith')}</span>
            <Heart className="w-4 h-4 text-red-500 animate-pulse" />
            <span className="text-gray-400 text-sm">{t('common:by')} {t('navigation:footer.team')}</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
